<template>
  <pt-integral-exchange-table class="pt-integral-exchange-table__page"></pt-integral-exchange-table>
</template>

<script>
import PtIntegralExchangeTable from 'cps//integral-mall-manage/pt-integral-exchange/pt-integral-exchange-table/withData'
export default {
  name: 'pt-integral-exchange-table__view',
  components: {
    'pt-integral-exchange-table': PtIntegralExchangeTable
  }
}
</script>
